module.exports = __webpack_public_path__ + "static/media/MorphTablet1.267b5e9a.png";